module.exports = __webpack_public_path__ + "img/logo-white.53f95310.png";